/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { BATTLE_TYPES } from 'constants'

import styles from './ConstructReserve.scss'

// almost the same text contains in helpers/i18n but here the are lowercase
// if it posible to fix it with css delete this texts and use from helpers
export const BATTLE_TYPE_MESSAGES = {
    [BATTLE_TYPES.ALL_BATTLES]: (
        <FormattedMessage
            id='construct_reserve.battle_types.all_battles'
            defaultMessage='во всех режимах боев'
        />
    ),
    [BATTLE_TYPES.RANDOM_BATTLES]: (
        <FormattedMessage
            id='construct_reserve.battle_types.random_battles'
            defaultMessage='в Случайных боях и на Линии фронта'
        />
    ),
    [BATTLE_TYPES.RANDOM_BATTLES_AND_STEEL_HUNTER]: (
        <FormattedMessage
            id='construct_reserve.battle_types.random_battles_and_steel_hunter'
            defaultMessage='в Случайных боях, а также на Линии фронта и в Стальном охотнике'
        />
    ),
    [BATTLE_TYPES.CLAN_BATTLES]: (
        <FormattedMessage
            id='construct_reserve.battle_types.clan_battles'
            defaultMessage='в клановых и турнирных боях'
        />
    ),
    [BATTLE_TYPES.SORTIE]: (
        <FormattedMessage
            id='construct_reserve.battle_types.sortie'
            defaultMessage='в Вылазках'
        />
    ),
    [BATTLE_TYPES.BATTLE_FOR_STRONGHOLD]: (
        <FormattedMessage
            id='construct_reserve.battle_types.battles_for_stronghold'
            defaultMessage='за результат проведённого Наступления'
        />
    ),
    [BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE]: (
        <FormattedMessage
            id='construct_reserve.battles_types.battle_for_stronghold_and_sortie'
            defaultMessage='в Вылазках и при Наступлениях на 1 бой'
        />
    ),
}

export const BEFORE_PREFIX = (
    <FormattedMessage
        id='construct_reserve.before_prefix'
        defaultMessage='до'
    />
)

export const CREW_EFFECTIVITY_BONUS = (value) => (
    <FormattedMessage
        id='construct_reserve.parameters.crew_effectivity_bonus'
        defaultMessage='до {value} к основной специальности и умениям экипажа'
        values={{
            value: (
                <span className={styles.parameterValue}>{value}</span>
            ),
        }}
    />
)

export const RANGE_OF_ACTION = (value) => (
    <FormattedMessage
        id='construct_reserve.parameters.range_of_action'
        defaultMessage='до {value} м. радиус действия'
        values={{
            value: (
                <span className={styles.parameterValue}>{value}</span>
            ),
        }}
    />
)

export const MAX_DAMAGE_FOR_VEHICLE_LEVELS = (values) => (
    <FormattedMessage
        id='construct_reserve.parameters.max_damage_for_vehicle_levels'
        defaultMessage='до {value} ед. максимального урона для боёв на VI / VIII / X уровне техники'
        values={{
            value: (
                <span>
                    {values.map((value, index) => (
                        <span key={index}>
                            {index !== 0 && <span className={styles.valueSeparator}>{' / '}</span>}
                            <span className={styles.parameterValue}>{value}</span>
                        </span>
                    ))}
                </span>
            ),
        }}
    />
)

export const RANGE_OF_AFFECTED_AREA = (value) => (
    <FormattedMessage
        id='construct_reserve.parameters.range_of_affected_area'
        defaultMessage='до {value} м. радиус зоны поражения'
        values={{
            value: (
                <span className={styles.parameterValue}>{value}</span>
            ),
        }}
    />
)

export const INSPIRATION_INDUSTRIAL_RESOURCE_BONUS = (value) => (
    <FormattedMessage
        id='construct_reserve.parameters.inspiration_industrial_resource_bonus'
        defaultMessage='до {value} к промресурсу при воодушевлении'
        values={{
            value: (
                <span className={styles.parameterValue}>{`+${value}`}</span>
            ),
        }}
    />
)

export const ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS = (value) => (
    <FormattedMessage
        id='construct_reserve.parameters.artillery_strike_industrial_resource_bonus'
        defaultMessage='до {value} к промресурсу при вызове артобстрела'
        values={{
            value: (
                <span className={styles.parameterValue}>{`+${value}`}</span>
            ),
        }}
    />
)



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructReserve/constants.jsx